export enum StoreKey {
  // 使用加密缓存本地（区分PC和WEB）
  USER_INFO = 'USER_INFO',
  TCD_USER_INFO = 'TCD_USER_INFO', // v2.0.2重构登录之后由USER_INFO改为TCD_USER_INFO
  ACCESS_TOKEN_MAP = 'ACCESS_TOKEN_MAP',
  SHARE_ACCESS_TOKEN_MAP = 'SHARE_ACCESS_TOKEN_MAP',
  COLLECT_ACCESS_TOKEN_MAP = 'COLLECT_ACCESS_TOKEN_MAP',
  SYNC_ACCESS_TOKEN_MAP = 'SYNC_ACCESS_TOKEN_MAP',
  WINDOW_STATE = 'WINDOW_STATE',
  SYSTEM_SETTING = 'SYSTEM_SETTING',
  DOWNLOAD_SETTING = 'DOWNLOAD_SETTING',
  UPLOAD_TRANSFER_SETTING = 'UPLOAD_TRANSFER_SETTING', // 上传传输设置
  DOWNLOAD_TRANSFER_SETTING = 'DOWNLOAD_TRANSFER_SETTING', // 下载传输设置
  TCD_ROUTE = 'TCD_ROUTE',
  INTERNAL_SMHURL = 'INTERNAL_SMHURL', // 私有化服务器地址

  // 使用浏览器缓存（不区分PC和WEB）
  LOGIN = 'LOGIN',
  VISTOR_LOGIN = 'VISTOR_LOGIN',
  ROUTE = 'ROUTE', // 2.2.0开始 废弃，使用TCD_ROUTE代替
  PREVIOUS_ROUTE = 'PREVIOUS_ROUTE', // 前一个路由
  // 搜索相关信息
  SEARCH_RECORD = 'SEARCH_RECORD', // 搜索历史记录
  SEARCH_PREVIOUS_ROUTE = 'SEARCH_PREVIOUS_ROUTE', // 搜索上一个路由信息
  SEARCH_SCOPE = 'SEARCH_SCOPE', // 搜索范围'all' || 'current' || '全局'
  SEARCH_KEYWORD = 'SEARCH_KEYWORD', // 搜索关键词
  SEARCH_CONDITION = 'SEARCH_CONDITION', // 搜索条件
  TEAM_PATH = 'TEAM_PATH',
  RECV_SHARE_SPACE = 'RECV_SHARE_SPACE',
  RECYCLE_PATH = 'RECYCLE_PATH',
  SHARE_LINK_ROOT_PATH = 'SHARE_LINK_ROOT_PATH',
  MAJOR_VERSION = 'MAJOR_VERSION',
  REMOTE_PATH = 'REMOTE_PATH',
  ROUTE_BEFORE_PREVIEW = 'ROUTE_BEFORE_PREVIEW', // 预览前的路由
  CUSTOM_ID_LIST = 'CUSTOM_ID_LIST', // 企业id操作记录
  SSO_ID_LIST = 'SSO_ID_LIST', // sso 租户id操作记录
  SSO_DOMAIN_LIST = 'SSO_DOMAIN_LIST', // yufu sso 租户域名操作记录【2.2.0废弃、domain不用存 需要存corpId】
  SSO_CORPID_LIST = 'SSO_CORPID_LIST', // yufu sso 企业id操作记录
  NEW_SSO_CORPID_LIST = 'NEW_SSO_CORPID_LIST', // sso 企业id操作记录
  LDAP_CORPID_LIST = 'LDAP_CORPID_LIST', // ldap 企业id操作记录
  ORG_INFO = 'ORG_INFO', // 用户所属企业信息
  OPEN_TEAM_TREE_IN_SIDEBAR = 'OPEN_TEAM_TREE_IN_TEAM_SPACE', // 侧边栏企业空间是否展开树形
  NOT_SHOW_TOP_ADVERT = 'NOT_SHOW_TOP_ADVERT', // 展示顶部的广告
  NOT_SHOW_RECYCLE_ADVERT = 'NOT_SHOW_RECYCLE_ADVERT', // 展示回收站的广告
  NOT_SHOW_BANNER_ADVERT = 'NOT_SHOW_BANNER_ADVERT', // 展示侧边栏的广告
  COSPACE_SELECT_LIST = 'COSPACE_SELECT_LIST', // 所选协作群组信息
  IMG_PREVIEW_LIST = 'IMG_PREVIEW_LIST', // 预览图片当前列表信息
  WECHAT_CODE_LIST = 'WECHAT_CODE_LIST', // 微信登录用的码缓存
  WECOM_CODE_LIST = 'WECOM_CODE_LIST', // 企微登录用的码缓存
  SSO_CODE_LIST = 'SSO_CODE_LIST', // sso登录用的码缓存
  PACK_UP_COLL_NOVICE_WORK = 'PACK_UP_COLL_NOVICE_WORK',
  PACK_UP_PERSONAL_NOVICE_WORK = 'PACK_UP_PERSONAL_NOVICE_WORK',
  SECURITY_SETTING = 'SECURITY_SETTING', // 安全设置
  PROXY_SETTING = 'PROXY_SETTING', // 代理地址
  WATERMARK_FLAG = 'WATERMARK_FLAG', // 水印设置修改标志

  LANGUAGE_SETTING = 'LANGUAGE_SETTING', // 语言设置
  CAS_LOGIN = 'CAS_LOGIN', // cas 登录信息
}
export interface SystemSetting {
  autoStart: boolean;
  minToTray: boolean;
  autoUpdate: boolean;
  syncVirtualDisk: boolean; // 是否显示同步盘虚拟盘符
}
export interface RangeLimit {
  chunkParallelLimit: number;
  batchLimit: number;
  retryLimit: number;
}

export interface DownloadSetting {
  downloadPath: string;
  noAskDownloadPath: boolean;
}
